import React, { useState } from "react";
import { useCampaigns, useJobs } from "../../state/Storage";
import Center from "../utils/Center";
import CampaignReport from "./CampaignReport";
import { Link } from "react-router-dom";
import Clipboard from "../utils/icons/Clipboard";
import { getUser } from "../../state/User";
import { formatDestination } from "../helpers";
import DestinationReport from "../destinations/DestinationReport";
import Send from "../utils/icons/Send";

export default function Reports() {
  const [campaigns] = useCampaigns();
  const user = getUser();
  const [selectedCampaignId, setSelectedCampaign] = useState<string | null>(
    null
  );
  const [selectedDestinationId, setSelectedDestination] = useState<
    string | null
  >(null);
  const selectedCampaign: Post | undefined = campaigns.find(
    (c) => c.id === selectedCampaignId
  );
  const selectedDestination: Destination | undefined = (
    user?.destinations || []
  ).find((d) => d.id === selectedDestinationId);

  if (campaigns.length === 0) {
    return (
      <div className="layout mt3">
        <h2 className="tac">Reports</h2>
        <p className="tac mt3">
          You still have no campaigns. Go create one <Link to="/">here</Link>.
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="layout mt3">
        <h2 className="tac mb2">Reports</h2>
        <div className="grid grid2">
          <div>
            <strong className="block mb1">Your campaigns:</strong>
            {campaigns.map((c) => {
              return (
                <button
                  key={c.id}
                  className="reset as-link block tac fz12"
                  onClick={() => {
                    setSelectedCampaign(c.id);
                    setSelectedDestination(null);
                  }}
                >
                  <Clipboard size={16} /> {c.title}
                </button>
              );
            })}
          </div>
          <div>
            <strong className="block mb1">Your destinations:</strong>
            {user?.destinations &&
              user.destinations.map((destination) => {
                return (
                  <button
                    key={destination.id}
                    className="reset as-link block tac fz12"
                    onClick={() => {
                      setSelectedDestination(destination.id);
                      setSelectedCampaign(null);
                    }}
                  >
                    <Send size={16} />{" "}
                    {formatDestination(destination, "button", false)}
                  </button>
                );
              })}
          </div>
        </div>
      </div>
      {selectedCampaign && (
        <>
          <hr className="mt3 mb1" />
          <h1 className="tac">{selectedCampaign.title}</h1>
          <hr className="mb1" />
          <CampaignReport
            post={selectedCampaign}
            key={selectedCampaignId || "key"}
          />
        </>
      )}
      {selectedDestination && (
        <>
          <hr className="mt3 mb1" />
          <h1 className="tac">
            {formatDestination(selectedDestination, "text", false)}
          </h1>
          <hr className="mb1" />
          <DestinationReport destination={selectedDestination} />
        </>
      )}
    </>
  );
}
